// Design tokens for the Add/Edit product modal and the restyled Order summary.
// Values come from the `C` map in claude-design-projects/UFG/UFG.dc.html (L514-520).
export const COLORS = {
    navy: 'rgb(0,59,111)',
    brand: 'rgb(90,143,195)',
    blue600: 'rgb(45,105,169)',
    blue400: 'rgb(107,140,174)',
    blue200: 'rgb(204,222,239)',
    blue100: 'rgb(238,243,255)',
    secondary: 'rgb(75,85,99)',
    tertiary: 'rgb(99,115,140)',
    divider: 'rgb(229,231,235)',
    gray100: 'rgb(243,244,246)',
    disabled: 'rgb(156,163,175)',
    accent: 'rgb(249,115,22)',
    error: 'rgb(239,68,68)',
    amber: 'rgb(251,191,36)',
    white: 'rgb(255,255,255)',
    giftBackground: 'rgb(255,237,213)',
    warningBackground: 'rgb(254,243,199)',
    warningIcon: 'rgb(245,158,11)',
    overlay: 'rgba(0,43,82,0.55)',
    paperOverlay: 'rgba(255,255,255,0.94)',
    cardOverlay: 'rgba(255,255,255,0.84)'
}

export const SHADOWS = {
    dialog: '0 20px 25px -5px rgba(0,0,0,.10), 0 8px 10px -6px rgba(0,0,0,.04)',
    sheet: '0 -12px 40px -12px rgba(0,43,82,0.4)',
    thumb: '0 1px 2px rgba(0,0,0,0.05)'
}

export const RADII = {
    card: '16px',
    box: '12px',
    field: '8px',
    checkbox: '4px',
    pill: '9999px'
}

// the design's bottom-sheet breakpoint
export const SHEET_BREAKPOINT = 600

// Set once on the modal paper and on the summary card so every row inherits it. These rows use plain
// Box/div text on purpose: MainTemplate's `body1` variant is 36px, and drops to 24px under 430px, so
// a MUI Typography here would lose its size on a phone (verified on dev).
export const FONT = "'Poppins', NotoSansThai, sans-serif"
